import { render, staticRenderFns } from "./ExamineeLocked.vue?vue&type=template&id=0defe40e&scoped=true&"
import script from "./ExamineeLocked.vue?vue&type=script&lang=js&"
export * from "./ExamineeLocked.vue?vue&type=script&lang=js&"
import style0 from "./ExamineeLocked.vue?vue&type=style&index=0&id=0defe40e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0defe40e",
  null
  
)

export default component.exports